import styled from 'styled-components';
import { Box, Button, Flexbox, Typography } from '@hiiretail/synergy-ui';

export const IdentityProvidersListWrapper = styled(Flexbox)`
  overflow: auto;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: #fff;
`;

export const CreatedStatusBox = styled(Box)`
  display: flex;
  border-radius: 4px;
  background-color: #047627;
`;

export const CreatingStatusBox = styled(Box)`
  display: flex;
  border-radius: 4px;
  background-color: #01b739d9;
`;

export const UpdatingStatusBox = styled(Box)`
  display: flex;
  border-radius: 4px;
  background-color: #6c6c6c;
`;

export const DisabledStatusBox = styled(Box)`
  display: flex;
  border-radius: 4px;
  background-color: #f44336;
`;

export const AccordionTitle = styled(Typography)`
  margin-bottom: 0;
`;

export const IdentityProviderActionButton = styled(Button)`
  margin-right: 12px;
`;
